import sensors from '@/utils/sensors/sensors_config'
//注释部分只需服务端做
// 实名授信流程
export default {
    //序号14-Process-流程阶段
    $creditPro(process_name: any, partner_id: any, stage_name: any, if_success: any) {
        sensors.track('Process', {
            process_name,//	流程名称
            partner_id,//	合作方id
            stage_name,//	阶段名称
            if_success,//	是否成功
        })
    },
    // //序号15-CertificationResult-实名认证结果
    // $cfr(if_pass: any, fail_reason: any) {
    //     sensors.track('CertificationResult', {
    //         if_pass,//	是否通过
    //         fail_reason,//	失败原因
    //     })
    // },
    // //序号16-PreCollisionScreening-撞库前筛
    // $preColls(if_pass: any, fail_reason: any, partner_id: any) {
    //     sensors.track('PreCollisionScreening', {
    //         if_pass,//	是否通过
    //         fail_reason,//	失败原因
    //         partner_id,//	合作方id
    //     })
    // },
    // //序号17-CollisionResult-撞库结果
    // $cr(fail_reason: any, partner_id: any) {
    //     sensors.track('CollisionResult', {
    //         fail_reason,//	失败原因
    //         partner_id,//	合作方id
    //     })
    // },
    //序号18、19 同上14
//    //序号20-PreCreditScreening-进件前筛
//      $preCredits(fail_reason: any, partner_id: any,if_pass:any) {
//         sensors.track('PreCreditScreening', {
//             fail_reason,//	失败原因
//             partner_id,//	合作方id
//             if_pass,//	是否通过
//         })
//     },
//    //序号21-CreditInitiation-授信发起
//      $creditInit( partner_id: any,if_pass:any) {
//         sensors.track('CreditInitiation', {
//             partner_id,//	合作方id
//             if_pass,//	是否通过
//         })
//     },
//    //序号22-CreditAuditResult-授信审核结果
//      $creditAudit(fail_reason: any, partner_id: any,if_pass:any) {
//         sensors.track('CreditAuditResult', {
//             fail_reason,//	失败原因
//             partner_id,//	合作方id
//             if_pass,//	是否通过
//         })
//     },

}